import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Collapse,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useTranslation } from "common/locales";
import { useState } from "react";
import styled from "styled-components";

export default function ListOfUsersWithFileAccess() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <>
      <ListItem key="arable" button onClick={toggleOpen}>
        <ListItemText primary={t("who.can.see.my.files")} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Nested in={open} timeout="auto" unmountOnExit>
        <List>
          <ListItem>
            <Typography
              display="block"
              whiteSpace="pre-line"
              noWrap={false}
              style={{ wordWrap: "break-word", overflowWrap: "break-word" }}
            >
              {t("who.can.see.my.files.explanation")}
            </Typography>
          </ListItem>
        </List>
      </Nested>
    </>
  );

  function toggleOpen() {
    setOpen(!open);
  }
}

const Nested = styled(Collapse)(
  ({ theme }) => `
    padding-left: ${theme.spacing(4)};
  `
);
